import React from 'react';
import { BaseLayoutColumn } from '../WidgetFormPanel/Components';
import { getLabelAndValuePairsFromChildProps } from './Utils';
import { type } from './types';
const WidgetForm = (props) => {
    var _a;
    return (React.createElement(BaseLayoutColumn, { spacing: 16, childrenEditorPath: 'children', childProps: (_a = props.childProps) !== null && _a !== void 0 ? _a : [], renderData: props.renderData, editMode: props.editMode }));
};
export const widgetForm = {
    type,
    getLabelValueAsTextPairs: getLabelAndValuePairsFromChildProps,
    childConfigs: (config) => config.children,
    component: WidgetForm,
};
